export function getFileDataAsync(file) {
    const MIN_SIZE = 64;
    const IMAGE_TYPE = 'jpeg';
    return new Promise((success, fail) => {
        if (!file) {
            return fail(new Error('Пустой файл.'));
        }
        if (!file.type || !file.type.startsWith('image/')) {
            return success({
                imageUrl: '',
                filename: file.name,
            });
        }
        const canvas = document.createElement('canvas');
        canvas.width = MIN_SIZE;
        canvas.height = MIN_SIZE;
        const context = canvas.getContext('2d');
        const img = new Image();
        img.onload = () => {
            if (img.width > img.height) {
                canvas.width = MIN_SIZE;
                canvas.height = (MIN_SIZE * img.height) / img.width;
            } else {
                canvas.width = (MIN_SIZE * img.width) / img.height;
                canvas.height = MIN_SIZE;
            }
            context.drawImage(img, 0, 0, canvas.width, canvas.height);
            const dataUrl = canvas.toDataURL('image/' + IMAGE_TYPE);
            success({
                imageUrl: dataUrl,
                filename: file.name,
            });
        };
        img.onerror = fail;
        img.src = URL.createObjectURL(file);
    });
}
